import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
// import isEqual from 'lodash/isEqual'
import findLast from 'lodash/findLast'
import axios from 'axios'
import fuelPlan from './fuel-plan'
import store from '@/store'
import moment from 'moment-timezone'
import { getTimeZone } from '@/config/time-zone'
import {
  addTripPlan as addTripPlanApi,
  getTripPlanList as getTripPlanListApi,
  deleteTripPlan as deleteTripPlanApi,
  getTripPlanInfo as getTripPlanInfoApi,
  editTripPlan as editTripPlanApi,
  sendRoute as sendRouteApi,
  getRecentTrips as getRecentTripsApi,
  setRecentTrip
} from '@/api/trip-plan'
import calculateInsertPointIndex from '@/tools/fuel-plan/insert-waypoints'
import resetRouteMsg from '@/views/map/components/dialog/reset-route'
import { truckWebFormatToApi, truckApiFormatToWeb } from '../truck'
import tripPlanService from './service'
import { getLegAndShare, routeJsonformat } from '@/server-routing/services/route-format'
import { DispatchComponents$ } from "@/shared-services"

export const tripPlanPointInfo = {
  value: '',
  timeZone: 'EST', // 时区，适用于出发点
  dwellTime: '', // 停留时间，适用于途经点
  departureTime: '', // 出发时间， 适用于出发点
  stopPointType: '', // The type of the current point, including starting point "origin", passing point "waypoint", destination point "target", fuel point "fuelStation", drag point "polylinePointDragDone"
  stopType: 'Location', // 停留类型
  pointType: '', // 该点的内容的类型。包括poi、address，用于地图上小卡片区分要展示的内容
  pointInfo: {},
  pointId: null,
  latitude: '',
  longitude: '',
  facilityId: null, // 如果该点类型为facility时, 保存facilityId
  poiId: null, // 如果该点类型为poi时，保存poi id，用于地图上点击对应poi时显示删除icon
  tid: null, // 如果该点类型为poi时，保存poi tid，用于地图上点击对应poi时显示删除icon
  sid: null, // 如果该点类型为poi时，保存poi sid，用于地图上点击对应poi时显示删除icon
  requestCompleted: false, // 是否更新过数据，如果是poi，在编辑保存过的路线时需要更新poi信息，如果是address，则需要请求该点详情信息
  disabled: false, // 禁止修改和移动
  note: '',
  appointmentTime: '',
  appointmentTimeZone: 'EST',
  uniqueIdentifier: null,
  hidden: false,
  via: [] // List of locations that must be passed through
}

export const tripPlanInfo = {
  settingList: [], // 路线设置
  tripPlanPoints: [], // 路线途经点
  truckInfo: {}, // 路线所选卡车
  routes: [], // 规划出的路线点
  id: null
}

export const WAYPOINT_STATE_WITHOUT_RECALCULATION_ROUTE = [
  'addFuelStop',
  'removeFuelStop',
  'addCityAndState',
  'saveRoute',
  'backfill',
  'reductionAddDrag',
  'reductionEditDrag',
  'reductionRemoveDrag'
]

// 将路线接口数据格式转换为前端格式
export function routeApiFormatToWeb(info) {
  return Object.assign({}, tripPlanInfo, {
    settingList: info.settings ? JSON.parse(info.settings) : [],
    tripPlanPoints: info.wayPoints ? JSON.parse(info.wayPoints) : [],
    truckInfo: info.truckInfo ? JSON.parse(info.truckInfo) : {},
    routes: info.routes ? JSON.parse(info.routes) : [],
    id: info.id || null,
    type: info.type
  })
}

export function routeWebFormatToApi(info) {
  return {
    id: info.id,
    settings: JSON.stringify(info.settingList),
    wayPoints: JSON.stringify(info.tripPlanPoints),
    truckInfo: JSON.stringify(info.truckInfo),
    routes: JSON.stringify(info.routes),
    type: info.type
  }
}

// 部分信息深层拷贝
export function getActiveRoute(route) {
  let data = Object.assign({}, route, {
    waypointList: [...route.waypointList],
    waypoint: [...route.waypoint]
  })
  if (data.fuelPlanWaypoints) data.fuelPlanWaypoints = [...route.fuelPlanWaypoints]
  if (data.fuelPlanResult) data.fuelPlanResult = Object.assign({}, route.fuelPlanResult)
  if (data.fuelPlanRoute) {
    let fuelPlanRoute = route.fuelPlanRoute
    data.fuelPlanRoute = Object.assign({}, fuelPlanRoute, {
      waypointList: [...fuelPlanRoute.waypointList],
      waypoint: [...fuelPlanRoute.waypoint]
    })
  }
  return data
}

// 冻结路线部分数据
export function freezeRouteData(route) {
  route.points = Object.freeze(route.points || [])
  route.shape = Object.freeze(route.shape || [])
  route.sections = Object.freeze(route.sections || [])
  route.routeJson = Object.freeze(route.routeJson || {})
  if (route.fuelPlanRoute) {
    route.fuelPlanRoute = freezeRouteData(route.fuelPlanRoute)
  }
  return route
}

export function stopTypeFormat(stopType) {
  if (stopType === 'Other' || !stopType) {
    return 'Location'
  } else if (['Pickup', 'Pick up'].includes(stopType)) {
    return 'Pick Up'
  } else {
    return stopType
  }
}

export function getRouteWaypointInfo(list) {
  return list.map(item => ({
    value: item.value,
    timeZone: item.timeZone,
    dwellTime: item.stopPointType === 'origin' ? '' : item.dwellTime,
    departureTime: item.departureTime,
    stopPointType: item.stopPointType,
    latitude: item.latitude,
    longitude: item.longitude
  }))
}

export function formatWaypointListInDrag(waypoints) {
  let list = []
  let dragList = []
  let vIndex = 0
  waypoints.map(item => {
    if (item.isDrag) {
      dragList.push({...item, dragInfo: { waypointIndex: Math.max(0, list.length - 1), viaIndex: vIndex++ }})
    } else {
      let lastW = list[list.length - 1]
      if (lastW && dragList.length) {
        lastW.via = dragList
        dragList = []
        vIndex = 0
      }
      list.push(item)
    }
  })
  return list
}

function getSaveRouteParams(info) {
  // 去除旅行计划中添加点和没有值的途经点
  let points = info.tripPlanPoints.filter(item => item.stopPointType !== 'addPoint' && item.value)
  let apiTruck = isEmpty(info.truckInfo) ? {} : truckWebFormatToApi(info.truckInfo)
  let routes = info.routes.map(item => {
    let obj = {
      routeJson: item.routeJson,
      routeType: 'ordinary'
    }
    if (item.routeType === 'fuelPlan') {
      obj.fuelPlanResult = item.fuelPlanResult
      obj.fuelPlanWaypoints = item.fuelPlanWaypoints
      obj.fuelPlanRoute = { routeJson: item.fuelPlanRoute.routeJson }
      obj.routeType = 'fuelPlan'
    }
    return obj
  })
  let params = routeWebFormatToApi(Object.assign({}, info, { tripPlanPoints: points, truckInfo: apiTruck, routes }))
  return params
}

// 初始化途经点列表
function initWaypints() {
  return {
    type: 'init',
    list: []
  }
}

function removeRecentTrips(userId) {
  for(let key in localStorage) {
    if (key.includes('recentTrips') && key !== `recentTrips_${userId}`) {
      localStorage.removeItem(key)
    }
  }
}

function removeFuelStopAndFormatVia(waypoints) {
  let list = []
  waypoints.map(item => {
    if (item.pointType !== 'fuelStation') {
      list.push(Object.assign({}, item))
      return null
    }
    let lastPoint = list[list.length - 1]
    if (item.via.length && lastPoint) {
      lastPoint.via = [...lastPoint.via, ...item.via]
    }
  })
  return Service.addWaypoint(list, null)
}

const Service = new tripPlanService()
const CancelToken = axios.CancelToken
const tripPlan = {
  namespaced: true,
  state: {
    ...fuelPlan.state,
    showRouteDetail: false,
    routeDetailTab: '',
    haveObtainedSavedTripPlanList: false, // 是否已获取保存的旅行计划列表
    getSavedTripPlanListError: '', // 获取保存的旅行计划列表接口报错信息
    settingList: ['harshTurn', 'unpaved'], // 旅行计划的设置列表
    tripPlanPoints: initWaypints(), // 当前编辑的旅行计划
    saveTripPlanList: [], // 保存的旅行计划列表
    calculateRouteResult: { type: 'init', list: [] }, // 规划的路线列表
    truckInfo: {}, // 旅行计划的卡车信息
    saveTripPlanInfo: Object.assign({}, tripPlanInfo), // 保存的当前旅行计划信息
    activeRoute: {}, // 选中的路线
    tripPlanInfo: null, // 规划路线所需参数,
    recentTrips: [], // 最近旅行路线
    isShowWaypoint: true,
    isShowSetting: true,
    detailTab: '', // 详情页标签
    axiosToken: {}, // axios 请求token，方便取消请求
    reproduceRoute: false,
    calculateRouteLoading: false,
    isCalculateRoute: false, // 是否计算过路线
    routeTabList: [],
    activeRouteId: null,
    historyTab: 'recentTrips',
    shareTripWaypoint: [],
    routeConditionType: '',
  },
  mutations: {
    ...fuelPlan.mutations,
    SET_ROUTE_CONDITION_TYPE(state, type) {
      state.routeConditionType = type
    },
    SET_HISTORY_TAB(state, status) {
      state.historyTab = status
    },
    SET_CALCULATE_ROUTE_LOADING(state, status) {
      state.calculateRouteLoading = status
    },
    SET_REPRODUCE_ROUTE(state, status) {
      state.reproduceRoute = status
    },
    SET_DETAIL_TAB(state, tab) {
      state.detailTab = tab
    },
    SET_AXIOS_TOKEN(state, tokens) {
      state.axiosToken = tokens
    },
    SET_SHOW_ROUTE_DETAIL(state, status) {
      state.showRouteDetail = status
    },
    SET_ROUTE_DETAIL_TAB(state, tab) {
      state.routeDetailTab = tab
    },
    SET_HAVE_OBTAINED_SAVE_TRIP_PLAN_LIST(state, status) {
      state.haveObtainedSavedTripPlanList = status
    },
    SET_GET_SAVE_TRIP_PLAN_LIST_ERROR(state, text) {
      state.getSavedTripPlanListError = text
    },
    SET_TRIP_PLAN_POINTS(state, info) {
      state.tripPlanPoints = Object.assign(info, { list: info.list || [] })
    },
    SET_SETTING_LIST(state, list) {
      state.settingList = list
    },
    SET_TRUCK_INFO(state, truckInfo) {
      state.truckInfo = truckInfo
    },
    SET_SAVE_TRIP_PLAN_LIST(state, list) {
      state.saveTripPlanList = list
    },
    INIT_TRIP_PLAN_STATE(state) {
      state.settingList = ['harshTurn', 'unpaved']
      state.tripPlanPoints = initWaypints()
      state.saveTripPlanInfo = Object.assign({}, tripPlanInfo)
      state.calculateRouteResult = { type: 'init', list: [] }
      state.showRouteDetail = false
      state.routeDetailTab = ''
      state.isShowWaypoint = true
      state.isShowSetting = true
      state.reproduceRoute = false
      state.axiosToken = {}
      state.activeRoute = {}
      state.tripPlanInfo = Object.assign({}, tripPlanInfo, { truckInfo: state.truckInfo })
      state.calculateRouteLoading = false
      state.detailTab = ''
      state.isCalculateRoute = false
      state.routeTabList = []
      state.activeRouteId = null
      state.routeConditionType = ''
    },
    SET_SAVE_TRIP_PLAN_INFO(state, info) {
      state.saveTripPlanInfo = info
    },
    SET_CALCULATE_ROUTE_RESULT(state, info) {
      let activeRoute = info.list.find(item => item.isActive)
      state.calculateRouteResult = info
      state.activeRoute = activeRoute ? getActiveRoute(activeRoute) : {}
    },
    SET_TRIP_PLAN_INFO(state, tripPlanInfo) {
      state.tripPlanInfo = tripPlanInfo
    },
    SET_ACTIVE_ROUTE_STATUS(state, status) {
      let route = state.calculateRouteResult.list.find(item => item.id === state.activeRoute.id)
      if (route) {
        route['showFuelPoi'] = status
        state.activeRoute = getActiveRoute(route)
      }
    },
    SET_RECENT_TRIPS(state, list) {
      state.recentTrips = list
    },
    SET_IS_SHOW_WAYPOINT(state, status) {
      state.isShowWaypoint = status
    },
    SET_IS_SHOW_SETTING(state, status) {
      state.isShowSetting = status
    },
    SET_IS_CALCULATE_ROUTE(state, status) {
      state.isCalculateRoute = status
    },
    SET_ROUTE_TAB_LIST(state, list) {
      state.routeTabList = list
    },
    SET_ACTIVE_ROURE_ID(state, id) {
      state.activeRouteId = id
    },
    SET_ACTIVE_ROUTE_TRIP_COST(state, { activeRoute, tripCost }) {
      let route = state.calculateRouteResult.list.find(item => item.id === activeRoute.id)
      if (!route) return null
      if (route.routeType === 'fuelPlan') {
        route.fuelPlanRoute.tripCostInfo = tripCost
      } else {
        route.tripCostInfo = tripCost
      }
      if (route.isActive) {
        state.activeRoute = getActiveRoute(route)
      }
    },
    SET_WAYPOINT_LIST(state, list) {
      state.shareTripWaypoint = list
    }
  },
  actions: {
    ...fuelPlan.actions,
    updateRouteConditionType({ commit }, type) {
      commit('SET_ROUTE_CONDITION_TYPE', type)
    },
    updateHistoryTab({ commit }, status) {
      commit('SET_HISTORY_TAB', status)
    },
    updateReproduceRoute({ commit }, status) {
      commit('SET_REPRODUCE_ROUTE', status)
    },
    updateAxiosToken({ state, commit }, { tokens, isClear }) {
      if (isClear) {
        commit('SET_AXIOS_TOKEN', {})
        commit('SET_FUEL_PLAN_AXIOS_TOKEN', {})
      } else {
        let token = Object.assign({}, state.axiosToken, tokens)
        commit('SET_AXIOS_TOKEN', token)
      }
    },
    updateDetailTab({ commit }, tab) {
      commit('SET_DETAIL_TAB', tab)
    },
    updateShowWaypointStatus({ commit }, status) {
      commit('SET_IS_SHOW_WAYPOINT', status)
      if (status) {
        commit('SET_IS_SHOW_SETTING', false)
      }
    },
    updateShowSettingStatus({ commit, dispatch }, status) {
      commit('SET_IS_SHOW_SETTING', status)
      if (status) {
        dispatch('updateShowWaypointStatus', false)
      }
    },
    updateRecentTrips({ commit, rootState }, params) {
      commit('SET_RECENT_TRIPS', params.list)
      if (params.isSave) {
        try {
          removeRecentTrips(rootState.user.userId)
          localStorage.setItem(`recentTrips_${rootState.user.userId}`, JSON.stringify(params.list))
        } catch(error) {
          console.log(error)
        }
      }
    },
    getRecentTrips({ state, dispatch, rootState }, isReacquire) {
      if (!isReacquire && state.recentTrips.length) return Promise.resolve(state.recentTrips)
      return getRecentTripsApi().then(res => {
        dispatch('updateRecentTrips', { list: res.data, isSave: true })
      }).catch(() => {
        let recentTrips = JSON.parse(localStorage.getItem(`recentTrips_${rootState.user.userId}`)) || []
        dispatch('updateRecentTrips', { list: recentTrips })
      })
    },
    addRecentTrips({ state, dispatch }, list) {
      let tripPlanInfo = state.tripPlanInfo
      let stopInfo = (list || tripPlanInfo.tripPlanPoints).filter(x => !!x.value).map(item => {
        return {
          type: item.pointType === 'address' ? 'here address' : item.pointType,
          id: item.pointId,
          latitude: item.latitude,
          longitude: item.longitude,
          addressName: item.value,
          city: item.pointInfo.city || '',
          state: item.pointInfo.state || '',
          zipCode: item.pointInfo.zipCode || item.pointInfo.postalCode || '',
          info: JSON.stringify(item)
        }
      })
      let routeOptions = {
        dirtRoad: tripPlanInfo.settingList.includes('unpaved'),
        toll: tripPlanInfo.settingList.includes('tollroad'),
        tunnel: tripPlanInfo.settingList.includes('tunnel'),
        difficultTurns: tripPlanInfo.settingList.includes('harshTurn')
      }
      let truckInfo = isEmpty(tripPlanInfo.truckInfo) ? {} : truckWebFormatToApi(tripPlanInfo.truckInfo)
      let params = {
        stopInfo,
        routeOptions: JSON.stringify(routeOptions),
        truckInfo: JSON.stringify(truckInfo)
      }
      setRecentTrip(params).then(() => {
        dispatch('getRecentTrips', true)
      })
    },
    updateTripPlanInfo({ commit }, tripPlanInfo) {
      commit('SET_TRIP_PLAN_INFO', tripPlanInfo)
    },
    resetTripPlan({ state, dispatch, rootState } ) {
      let lastWaypoint = state.tripPlanPoints.list.find(item => item.value)
      // 取消未完成的请求
      let tokens = [
        rootState.map.axiosToken.calculateRouteAsidePoiSource,
        ...Object.values(state.axiosToken),
        ...Object.values(state.fuelPlanAxiosToken)
      ].filter(item => !!item)
      tokens.map(item => item.cancel('cancel request'))
      dispatch('updateAxiosToken', { isClear: true })
      dispatch('map/updateMapAxiosToken', { isClear: true }, { root: true })
      dispatch('initTripPlanState')
      dispatch('updateCalculateRouteResult', { type: 'init', list: [] })
      if (lastWaypoint) {
        dispatch('map/updateCenterPosition', { lat: lastWaypoint.latitude, lng: lastWaypoint.longitude }, { root: true })
      }
    },
    updateShowRouteDetailStatus({ commit }, { isShow, tab }) {
      commit('SET_SHOW_ROUTE_DETAIL', isShow)
      commit('SET_ROUTE_DETAIL_TAB', tab)
    },
    updateSettingList({ commit, dispatch, state }, setting) {
      commit('SET_SETTING_LIST', setting)
      dispatch('updateRouteConditionType', 'updateSetting')
      if (state.calculateRouteResult.list && state.calculateRouteResult.list.length) {
        dispatch('updateCalculateRouteResult', { type: 'init', list: [], routeConditionType: 'updateSetting' })
      }
    },
    updateTripPlanPoints({ commit, state, dispatch, rootState }, info) {
      let _p = info.list.filter(item => item.value).map(item => ({
        ...item,
        uniqueIdentifier: item.uniqueIdentifier ? item.uniqueIdentifier : `${item.pointId}-${item.latitude}-${item.longitude}-${Date.now()}`
      }))
      _p = state.tripPlanPoints.list.length && !info.reset ? Service.getWaypointList(_p, state.tripPlanPoints.list) : _p
      commit('SET_TRIP_PLAN_POINTS', { ...info, list: _p })
      if (_p.length <= 1) {
        commit('SET_CALCULATE_ROUTE_LOADING', false)
      }
      if (['reductionAddDrag', 'reductionEditDrag', 'reductionRemoveDrag', 'backfill'].includes(info.type)) {
        dispatch('addRecentTrips', _p) 
      }
      if (!WAYPOINT_STATE_WITHOUT_RECALCULATION_ROUTE.includes(info.type)) {
        // 取消不需要的请求
        let invalidRequest = [
          state.axiosToken.calculateRouteSource,
          state.axiosToken.calculateFuelRouteSource,
          rootState.map.axiosToken.calculateRouteAsidePoiSource,
          ...Object.values(state.fuelPlanAxiosToken),
        ].filter(item => !!item)
        invalidRequest.map(item => item.cancel('cancel request'))
        dispatch('closeRouteDetail')
        dispatch('updateRouteConditionType', info.type)
        if (
          state.calculateRouteResult.list.length > 0
          && !info.isShowRoute
        ) {
          dispatch('updateCalculateRouteResult', { type: 'init', list: [], routeConditionType: info.type })
        }
      }
    },
    updateTripPlanPointsConfirm({ state, dispatch }, info) {
      if (state.activeRoute.routeType === 'fuelPlan') {
        resetRouteMsg.msgbox({
          visible: true,
          callback: () => {
            let newList = removeFuelStopAndFormatVia(info.list)
            let oldList = removeFuelStopAndFormatVia(state.tripPlanPoints.list)
            dispatch('updateTripPlanPoints', {
              ...info,
              isShowRoute: false,
              list: Service.getWaypointList(newList, oldList),
              reset: true
            })
            info.callback && info.callback()
          },
          close: () => {
            info.close && info.close()
          }
        })
      } else {
        dispatch('updateTripPlanPoints', info)
        info.callback && info.callback()
      }
    },
    updateTruckInfo({ commit, dispatch, state }, truck) {
      commit('SET_TRUCK_INFO', truck)
      dispatch('updateFuelStopWaypoint')
      dispatch('updateRouteConditionType', 'updateTruck')
      if (state.calculateRouteResult.list && state.calculateRouteResult.list.length) {
        dispatch('updateCalculateRouteResult', { type: 'init', list: [], routeConditionType: 'updateTruck' })
      }
    },
    updateCalculateRouteResult({ commit, dispatch }, info) {
      commit('SET_CALCULATE_ROUTE_RESULT', info)
      if (info.list.length === 0) {
        dispatch('closeRouteDetail')
        dispatch('updateRouteTabList')
        dispatch('updateActiveRouteId', null)
        dispatch('map/updateShowMarkerStatus', false, { root: true })
      }
    },
    closeRouteDetail({ dispatch, rootState }) {
      let showLeftDrawerList = rootState.siderbar.showLeftDrawerList
      let currentDrawer = showLeftDrawerList[showLeftDrawerList.length - 1]
      if (currentDrawer && currentDrawer.type === 'route-detail') {
        dispatch('siderbar/popLeftDrawer', null, { root: true })
      }
    },
    updateActiveRouteTripCost({ commit }, { activeRoute, tripCost }) {
      commit('SET_ACTIVE_ROUTE_TRIP_COST', { activeRoute, tripCost })
    },
    switchRoute({ state, dispatch }, routeId) {
      let routes = state.calculateRouteResult.list
      let activeRoute = null
      let arr = ['fuelSuccessful', 'fuelPlan', 'fuelLoading']
      let clickRoute = routes.find(item => item.id === routeId)
      if (clickRoute.isActive) return null
      let oldActiveRoute = routes.find(item => item.isActive)
      routes = routes.map(item => {
        let data = Object.assign({}, item)
        if (data.fuelPlanRoute) {
          data.fuelPlanRoute = Object.assign({}, item.fuelPlanRoute)
        }

        if (routeId === item.id) {
          data.isActive = true
          activeRoute = data
        } else {
          data.isActive = false
        }
        return data
      })
      dispatch('updateCalculateRouteResult', { type: 'switch', list: routes, newId: routeId, oldId: oldActiveRoute.id })
      if (activeRoute && !arr.includes(activeRoute.routeType)) {
        dispatch('calcFuelPlan', { route: activeRoute })
      }
    },
    updateRouteTabList({ commit, state }) {
      let list = state.calculateRouteResult.list.filter(item => !item.disabled)
      if (list.length >= 2) {
        commit('SET_ROUTE_TAB_LIST', state.calculateRouteResult.list.map((item, index) => ({
          id: item.routeType === 'fuelPlan' ? item.fuelPlanRoute.id : item.id,
          label: `Route ${index + 1}`
        })))
      } else {
        commit('SET_ROUTE_TAB_LIST', [])
      }
    },
    updateActiveRouteId({ commit }, id) {
      commit('SET_ACTIVE_ROURE_ID', id)
    },
    updateActiveRouteStatus({ commit }, status) {
      commit('SET_ACTIVE_ROUTE_STATUS', status)
    },
    initTripPlanState({ commit }) {
      commit('INIT_TRIP_PLAN_STATE')
      commit('INIT_FUEL_PLAN')
    },
    // 添加途经点列表
    addTripPlanWaypointList({ dispatch }, waypoints) {
      let points = Service.addWaypoint(waypoints, null)
      dispatch('updateTripPlanPointsConfirm', { type: 'addList', list: points })
    },
    // 添加途经点
    addTripPlanWaypoint({ state, dispatch }, point) {
      let points = Service.addWaypoint(state.tripPlanPoints.list, point)
      dispatch('updateTripPlanPointsConfirm', { type: 'add', list: points })
      dispatch('updateShowWaypointStatus', true)
      setTimeout(() => {
        dispatch('map/updateCenterPosition', { lat: point.latitude, lng: point.longitude }, { root: true })
      }, 20)
    },
    smartAddTripPlanWaypoint({ state, dispatch }, point) {
      let index = calculateInsertPointIndex(state.tripPlanPoints.list, point)
      let points = [...state.tripPlanPoints.list]
      points.splice(index, 0, point)
      dispatch('updateTripPlanPointsConfirm', { type: 'add', list: Service.addWaypoint(points, null) })
      dispatch('updateShowWaypointStatus', true)
      setTimeout(() => {
        dispatch('map/updateCenterPosition', { lat: point.latitude, lng: point.longitude }, { root: true })
      }, 20)
    },
    // 更新途经点
    updateTripPlanWaypoint({ state, dispatch }, info) {
      let points = [...state.tripPlanPoints.list].map(item => {
        if (item.uniqueIdentifier === info.uniqueIdentifier) {
          return Object.assign({}, item, info)
        } else {
          return item
        }
      })
      dispatch('updateTripPlanPointsConfirm', { type: 'update', list: points, close: info.close, callback: info.callback })
      setTimeout(() => {
        dispatch('map/updateCenterPosition', { lat: info.latitude, lng: info.longitude }, { root: true })
      }, 20)
    },
    // 删除途经点
    removeTripPlanWaypoint({ state, dispatch }, id) {
      let points = Service.removePoint(state.tripPlanPoints.list, id)
      let info = findLast(points, item => item.value && item.latitude && item.longitude)
      dispatch('updateTripPlanPointsConfirm', { type: 'remove', list: points })
      dispatch('updateShowWaypointStatus', true)
      setTimeout(() => {
        if (info) {
          dispatch('map/updateCenterPosition', { lat: info.latitude, lng: info.longitude }, { root: true })
        }
      }, 20)
    },
    updateFuelStopWaypoint({ state, dispatch }) {
      if (state.tripPlanPoints.list.some(item => item.pointType === 'fuelStation')) {
        let list = removeFuelStopAndFormatVia(state.tripPlanPoints.list)
        dispatch('updateTripPlanPoints', { type: 'updateFuelStop', list, reset: true })
      }
    },
    // Add drag point
    addDragPointToWaypoint({ state, dispatch }, info) {
      let list = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.waypointIndex) {
          item.via = item.via || []
          item.via.splice(info.viaIndex, 0, info.point)
        }
        return item
      })
      dispatch('map/updateCenterPosition', null, { root: true })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'addDragPoint',
        isShowRoute: true,
        list,
        reset: true,
        callback: info.callback,
        dragInfo: { waypointIndex: info.waypointIndex, uniqueIdentifier: info.point.uniqueIdentifier }
      })
    },
    reductionAddDrag({ state, dispatch }) {
      let info = state.tripPlanPoints.dragInfo
      let list = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.waypointIndex) {
          item.via = item.via.filter(v => v.uniqueIdentifier !== info.uniqueIdentifier)
        }
        return item
      })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'reductionAddDrag',
        isShowRoute: true,
        list: list,
        reset: true
      })
    },
    editDragPointToWaypoint({ state, dispatch }, info) {
      let oldPoint = null
      let points = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.dragInfo.waypointIndex) {
          item.via = item.via.map(v => {
            if (v.uniqueIdentifier === info.uniqueIdentifier) {
              oldPoint = cloneDeep(v)
              return Object.assign({}, v, info)
            } else {
              return v
            }
          })
        }
        return item
      })
      dispatch('map/updateCenterPosition', null, { root: true })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'updateDragPoint',
        isShowRoute: true,
        list: points,
        close: info.close,
        reset: true,
        callback: info.callback,
        dragInfo: {
          waypointIndex: info.dragInfo.waypointIndex,
          uniqueIdentifier: info.uniqueIdentifier,
          point: oldPoint
        }
      })
    },
    reductionEditDrag({ state, dispatch }) {
      let info = state.tripPlanPoints.dragInfo
      let list = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.waypointIndex) {
          item.via = item.via.map(v => {
            if (v.uniqueIdentifier === info.uniqueIdentifier) {
              return Object.assign({}, info.point)
            } else {
              return v
            }
          })
        }
        return item
      })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'reductionEditDrag',
        isShowRoute: true,
        list: list,
        reset: true
      })
    },
    removeDragPointToWaypoint({ state, dispatch }, info) {
      let oldPoint = null
      let viaIndex = 0
      let points = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.waypointIndex) {
          let list = []
          item.via.map((v, i) => {
            if (v.uniqueIdentifier === info.uniqueIdentifier) {
              oldPoint = v
              viaIndex = i
            } else {
              list.push(v)
            }
          })
          item.via = list
        }
        return item
      })
      dispatch('map/updateCenterPosition', null, { root: true })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'removeDragPoint',
        isShowRoute: true,
        list: points,
        reset: true,
        dragInfo: {
          waypointIndex: info.waypointIndex,
          uniqueIdentifier: info.uniqueIdentifier,
          point: oldPoint,
          viaIndex: viaIndex
        }
      })
    },
    reductionRemoveDrag({ state, dispatch }) {
      let info = state.tripPlanPoints.dragInfo
      let list = cloneDeep(state.tripPlanPoints.list).map((item, index) => {
        if (index === info.waypointIndex) {
          item.via = item.via || []
          item.via.splice(info.viaIndex, 0, info.point)
        }
        return item
      })
      dispatch('updateTripPlanPointsConfirm', {
        type: 'reductionRemoveDrag',
        isShowRoute: true,
        list,
        reset: true
      })
    },
    reduction({ dispatch }, type) {
      switch(type) {
        case 'addDragPoint':
          dispatch('reductionAddDrag')
          break
        case 'updateDragPoint':
          dispatch('reductionEditDrag')
          break
        default:
          dispatch('reductionRemoveDrag')
      }
    },
    // 初始化旅行计划
    initTripPlanPoints({ dispatch }) {
      dispatch('updateTripPlanPoints', initWaypints())
    },
    /**
     * 获取保存的旅行计划列表
     */
    getSaveTripPlanList({ commit }) {
      let params = { ifPageAble: 0 }
      return getTripPlanListApi(params).then(
        result => {
          commit('SET_HAVE_OBTAINED_SAVE_TRIP_PLAN_LIST', true)
          try {
            let data = result.data.data.map(item => {
              item.wayPoints = item.wayPoints ? JSON.parse(item.wayPoints) : []
              return item
            })
            commit('SET_SAVE_TRIP_PLAN_LIST', data)
            commit('SET_GET_SAVE_TRIP_PLAN_LIST_ERROR', '')
            return Promise.resolve(data)
          } catch(error) {
            commit('SET_GET_SAVE_TRIP_PLAN_LIST_ERROR', error)
            return Promise.reject(error)
          }
        },
        error => {
          commit('SET_GET_SAVE_TRIP_PLAN_LIST_ERROR', error)
          return Promise.reject(error)
        }
      )
    },
    /**
     * 获取路线的信息
     * @param {*} context 
     * @param {*} info 
     */
    getSaveTripPlanInfo({ commit, state, rootState, dispatch }, info) {
      // 取消不需要的请求
      let invalidRequest = [
        state.axiosToken.getSaveTripPlanInfoSource,
        state.axiosToken.calculateRouteSource
      ].filter(item => !!item)
      invalidRequest.map(item => item.cancel('cancel request'))

      // 创建新的请求token
      let source = CancelToken.source()
      dispatch('updateAxiosToken', { tokens: { getSaveTripPlanInfoSource: source } })

      return getTripPlanInfoApi(info.id, source.token).then(
        async result => {
          try {
            let data = routeApiFormatToWeb(result.data)
            // 途经点
            data.tripPlanPoints = Service.addWaypoint(formatWaypointListInDrag(data.tripPlanPoints.filter(item => item.stopPointType !== 'addPoint')).map(item => {
              item.requestCompleted = false
              item.stopType = stopTypeFormat(item.stopType)
              if (!item.pointId) {
                if (item.pointType === 'poi') {
                  item.pointId = item.poiId
                } else if (item.pointType === 'facility') {
                  item.pointId = item.facilityId
                } else {
                  item.pointId = (item.pointInfo || {}).pointId
                }
              }
              return item
            }))
            // 卡车
            data.truckInfo = isEmpty(data.truckInfo) ? {} : Object.assign(truckApiFormatToWeb(data.truckInfo), { isActive: true })

            let tripPlanPoints = data.tripPlanPoints
            let lastPoints = tripPlanPoints[tripPlanPoints.length - 1]
            let routes = []
            let truckList = [...rootState.truck.truckList]
            let tripPlanInfo = {
              settingList: data.settingList,
              tripPlanPoints: tripPlanPoints,
              truckInfo: data.truckInfo,
              id: info.id,
              routes
            }

            if (data.truckInfo.id && !rootState.truck.truckList.find(item => item.id === data.truckInfo.id)) {
              truckList.push(data.truckInfo)
            }
            truckList = truckList.map(i => {
              if (i.id === data.truckInfo.id) {
                return Object.assign({}, i, { isActive: true })
              } else {
                return Object.assign({}, i, { isActive: false })
              }
            })

            if (data.routes.length) {
              let activeRoute = data.routes[0]
              if (activeRoute.routeType === 'fuelPlan' && activeRoute.fuelPlanWaypoints && tripPlanPoints.length === activeRoute.fuelPlanWaypoints.length) {
                activeRoute.fuelPlanRoute = Service.serverRoutingFormatRoute(activeRoute.fuelPlanWaypoints, activeRoute.fuelPlanRoute.routeJson)[0]
              } else {
                activeRoute.routeType = 'ordinary'
                activeRoute.fuelPlanRoute = null
              }
              routes = Service.serverRoutingFormatRoute(data.tripPlanPoints, activeRoute.routeJson).map(item => {
                return Object.assign({}, item, activeRoute)
              })
              // Compatible with old data without departure time
              let originWaypoint = tripPlanPoints[0]
              let timeZone = originWaypoint.timeZoneFull || originWaypoint.timeZone
              if (!originWaypoint.departureTime || originWaypoint.departureTime.length === 5) {
                originWaypoint.departureTime =
                  moment(routes[0].summary.departure, 'X')
                  .tz(getTimeZone(timeZone)).format('YYYY-MM-DD HH:mm:ss')
              }
            }
            tripPlanInfo.routes = data.routes = routes

            commit('SET_IS_CALCULATE_ROUTE', true)
            commit('SET_IS_SHOW_WAYPOINT', false)
            commit('SET_IS_SHOW_SETTING', false)
            data.type !== 'send' && commit('SET_SAVE_TRIP_PLAN_INFO', cloneDeep(data))
            commit('SET_SETTING_LIST', data.settingList)
            commit('SET_TRUCK_INFO', data.truckInfo)
            dispatch('updateTripPlanPoints', { type: 'saveRoute', reset: true, list: tripPlanPoints })
            dispatch('updateTripPlanInfo', tripPlanInfo)
            dispatch('updateCalculateRouteResult', { type: 'saveRoute', list: routes })
            dispatch('map/updateCenterPosition', { lat: lastPoints.latitude, lng: lastPoints.longitude }, { root: true })
            dispatch('map/updateShowMarkerStatus', false, { root: true })
            dispatch('truck/updateTruckList', truckList, { root: true })
            dispatch('siderbar/updateShowSecondarySiderbar', false, { root: true })
            if (routes.length && routes[0].routeType !== 'fuelPlan') {
              dispatch('calcFuelPlan', { route: routes[0] })
            }

            // 删除请求token
            dispatch('updateAxiosToken', { tokens: { getSaveTripPlanInfoSource: null, calculateRouteSource: null } })

            return Promise.resolve(Object.assign({}, data, { tripPlanPoints }))
          } catch(error) {
            // 删除请求token
            dispatch('updateAxiosToken', { tokens: { getSaveTripPlanInfoSource: null, calculateRouteSource: null } })
            return Promise.reject(error)
          }
        },
        error => {
          // 删除请求token
          dispatch('updateAxiosToken', { tokens: { getSaveTripPlanInfoSource: null, calculateRouteSource: null } })
          return Promise.reject(error)
        }
      )
    },
    /**
     * 保存旅行计划
     *
     * @param {*} { commit }
     * @param {tripPlanInfo} info 旅行计划的信息 
     * @returns
     */
    saveTripPlan({ commit, state }, info) {
      let params = getSaveRouteParams(info)
      return addTripPlanApi(params).then(
        result => {
          try {
            if (params.type === 'send') return Promise.resolve(result)
            let points = info.tripPlanPoints.filter(item => item.stopPointType !== 'addPoint' && item.value)
            let data = result.data
            let saveTripPlanList = [...state.saveTripPlanList]
            let route = Object.assign({}, info, { id: data.id })
            saveTripPlanList.unshift({ id: route.id, wayPoints: points })
            commit('SET_SAVE_TRIP_PLAN_LIST', saveTripPlanList)
            commit('SET_SAVE_TRIP_PLAN_INFO', route)
            return Promise.resolve(result)
          } catch(error) {
            return Promise.reject(error)
          }
        },
        error => Promise.reject(error)
      )
    },
    /**
     * 更新保存的旅行计划
     *
     * @param {*} { commit }
     * @param {tripPlanInfo} info 旅行计划的信息 
     */
    updateTripPlan({ commit, state }, info) {
      let params = getSaveRouteParams(info)
      return editTripPlanApi(params).then(
        result => {
          try {
            let points = info.tripPlanPoints.filter(item => item.stopPointType !== 'addPoint' && item.value)
            let data = result.data
            let saveTripPlanList = [...state.saveTripPlanList]
            let index = saveTripPlanList.findIndex(item => item.id === info.id)
            let route = Object.assign({}, info, { id: data.id })
            saveTripPlanList.splice(index, 1, { id: route.id, wayPoints: points })
            commit('SET_SAVE_TRIP_PLAN_LIST', saveTripPlanList)
            commit('SET_SAVE_TRIP_PLAN_INFO', route)
            return Promise.resolve(result)
          } catch(error) {
            return Promise.reject(error)
          }
        },
        error => Promise.reject(error)
      )
    },
    /**
     * 删除旅行计划
     *
     * @param {*} { commit }
     * @param {tripPlanInfo} info 旅行计划的信息 
     * @returns
     */
    removeTripPlan({ commit, state }, info) {
      return deleteTripPlanApi(info.id).then(
        result => {
          let saveTripPlanList = [...state.saveTripPlanList]
          let index = saveTripPlanList.findIndex(item => item.id === info.id)
          let saveTripPlanInfo = state.saveTripPlanInfo
          saveTripPlanList.splice(index, 1)
          commit('SET_SAVE_TRIP_PLAN_LIST', saveTripPlanList)
          if (saveTripPlanInfo.id === info.id) {
            commit('SET_SAVE_TRIP_PLAN_INFO', cloneDeep(tripPlanInfo))
          }
          return Promise.resolve(result)
        },
        error => Promise.reject(error)
      )
    },
    // 计算路线
    calculateRoute({ dispatch, state, rootState, commit }, { isChangeLoadingStatus=false } = {}) {
      // 取消不需要的请求
      let invalidRequest = [
        state.axiosToken.getSaveTripPlanInfoSource,
        state.axiosToken.calculateFuelRouteSource,
        rootState.map.axiosToken.calculateRouteAsidePoiSource,
        ...Object.values(state.fuelPlanAxiosToken),
      ].filter(item => !!item)
      invalidRequest.map(item => item.cancel('cancel request'))
      if (state.axiosToken.calculateRouteSource) {
        state.axiosToken.calculateRouteSource.cancel('cancel route request')
      }
      // 创建新的请求token
      let source = CancelToken.source()
      dispatch('updateAxiosToken', { tokens: { calculateRouteSource: source } })
      let tripPlanInfo = state.tripPlanInfo
      dispatch('map/updateShowMarkerStatus', false, { root: true })
      if (isChangeLoadingStatus) {
        commit('SET_CALCULATE_ROUTE_LOADING', true)
      }
      commit('SET_IS_CALCULATE_ROUTE', true)
      return Service.calculateRoute(tripPlanInfo, {}, rootState.user.userId, source.token).then(
        res => {
          dispatch('updateCalculateRouteResult', { type: 'calculateRoute', list: res, routeConditionType: state.routeConditionType })
          dispatch('updateRouteTabList')
          dispatch('updateActiveRouteId', res[0] ? res[0].id : null)
          dispatch('calcAllFuelPlan')

          // 删除请求token
          dispatch('updateAxiosToken', { tokens: { calculateRouteSource: null } })
          if (isChangeLoadingStatus) {
            commit('SET_CALCULATE_ROUTE_LOADING', false)
          }
          store.dispatch("user/setNotShowMessage");
          return Promise.resolve(res)
        },
        error => {
          if (error === 'cancel route request') {
            return Promise.reject(error)
          }
          // 删除请求token
          dispatch('updateAxiosToken', { tokens: { calculateRouteSource: null } })
          if (isChangeLoadingStatus) {
            commit('SET_CALCULATE_ROUTE_LOADING', false)
          }
          if (
            ['addDragPoint', 'updateDragPoint', 'removeDragPoint'].includes(state.routeConditionType)
            && state.calculateRouteResult.list.length
          ) {
            dispatch('reduction', state.routeConditionType)
            return Promise.reject({ type: 'drag error', error })
          }
          dispatch('updateCalculateRouteResult', { type: 'init', list: [], routeConditionType: state.routeConditionType })
          return Promise.reject(error)
        }
      )
    },
    // 计算加入fuel stop的路线
    calculateFuelRoute({ dispatch, state, rootState }) {
      // 取消不需要的请求
      let invalidRequest = [
        state.axiosToken.calculateFuelRouteSource,
        rootState.map.axiosToken.calculateRouteAsidePoiSource
      ].filter(item => !!item)
      invalidRequest.map(item => item.cancel('cancel request'))

      // 创建新的请求token
      let source = CancelToken.source()
      dispatch('updateAxiosToken', { tokens: { calculateFuelRouteSource: source } })

      let activeRoute = state.activeRoute
      let tripPlanInfo = {
        ...state.tripPlanInfo,
        tripPlanPoints: activeRoute.fuelPlanWaypoints
      }
      let params = { alternatives: 1 }
      dispatch('map/updateShowMarkerStatus', false, { root: true })
      return Service.calculateRoute(tripPlanInfo, params, rootState.user.userId, source.token).then(
        res => {
          let _pointList = activeRoute.fuelPlanWaypoints.map(item => {
            let _l = state.tripPlanPoints.list.find(i => i.uniqueIdentifier === item.uniqueIdentifier)
            return _l ? Object.assign({}, _l, { via: item.via }) : Object.assign({}, tripPlanPointInfo, item)
          })
          let fuelPlanRoute = res[0]
          let list = state.calculateRouteResult.list.map(item => {
            item = Object.assign({}, item)
            if (item.id === activeRoute.id) {
              item['fuelPlanRoute'] = fuelPlanRoute
              item['routeType'] = 'fuelPlan'
              item.disabled = false
            } else {
              item.disabled = true
            }
            return item
          })
          dispatch('updateTripPlanPoints', { type: 'addFuelStop', reset: true, list: Service.addWaypoint(_pointList, null) })
          dispatch('updateCalculateRouteResult', { type: 'addFuelRoute', list: list })
          dispatch('updateRouteTabList')
          dispatch('updateActiveRouteId', fuelPlanRoute.id)
          // 删除请求token
          dispatch('updateAxiosToken', { tokens: { calculateFuelRouteSource: null } })
          return Promise.resolve()
        },
        error => {
          // 删除请求token
          dispatch('updateAxiosToken', { tokens: { calculateFuelRouteSource: null } })
          return Promise.reject(error)
        }
      )
    },
    removeFuelRoute({ dispatch, state }) {
      let _pointList = removeFuelStopAndFormatVia(state.tripPlanPoints.list)
      let activeRouteId = null
      let routeList = state.calculateRouteResult.list.map(item => {
        item = Object.assign({}, item, { disabled: false })
        if (item.routeType === 'fuelPlan') {
          item.routeType = 'fuelSuccessful'
          item.fuelPlanRoute = null
        }
        if (item.isActive) {
          activeRouteId = item.id
        }
        return item
      })
      dispatch('updateTripPlanPoints', { type: 'removeFuelStop', reset: true, list: _pointList })
      dispatch('updateCalculateRouteResult', { type: 'removeFuelRoute', list: routeList })
      dispatch('updateRouteTabList')
      dispatch('updateActiveRouteId', activeRouteId)
    },
    // 发送路线
    sendRoute({ state }, user) {
      let params = {}
      try {
        let settingList = state.settingList
        let truckModel = isEmpty(state.truckInfo) ? {} : truckWebFormatToApi(state.truckInfo)
        let activeRoute = state.activeRoute
        let route = {}
        if (activeRoute.routeType === 'fuelPlan') {
          route = activeRoute.fuelPlanRoute
        } else {
          route = activeRoute
        }
        let waypoint = route.waypointList.filter(item => !item.hidden).map(item => {
          return {
            mappedPosition: item.mappedPosition,
            originalPosition: item.originalPosition,
            shapeIndex: item.v1ShapeIndex,
            mappedRoadName: item.value,
            timezone: route.waypointList[0].timeZone,
            stopType: item.stopType
          }
        })
        params = {
          routingMode: isEmpty(state.truckInfo) ? 'car' : 'truck',
          routingOption: {
            difficultTurns: settingList.includes('harshTurn') ? true : false,
            dirtRoad: settingList.includes('unpaved') ? true : false,
            toll: settingList.includes('tollroad') ? true : false,
            tunnel: settingList.includes('tunnel') ? true : false
          },
          sendToUserId: user.id,
          shape: route.v1Shape,
          sendText: user.sendText,
          waypoint,
          truckModel,
          ...getLegAndShare(route.routeJson, route.waypointList)
        }
      } catch(error) {
        return Promise.reject(error)
      }
      return sendRouteApi(params).then(res => res)
    },
    addWaypointCityAndState({ dispatch, state }, info) {
      if (state.tripPlanPoints.list.find(item => item.uniqueIdentifier === info.uniqueIdentifier)) {
        let points = [...state.tripPlanPoints.list].map(item => {
          if (item.uniqueIdentifier === info.uniqueIdentifier) {
            return Object.assign({}, info)
          } else {
            return item
          }
        })
        dispatch('updateTripPlanPoints', {type: 'addCityAndState', list: points })
      }
    },
    getWaypointCityAndState({ dispatch, state }) {
      state.tripPlanPoints.list.map(item => {
        if (!('city' in item.pointInfo)) {
          let api = null
          let params = null
          switch(item.pointType) {
            case 'address':
              api = 'search/getAddressDetailV3'
              params = item.pointInfo
              break
            case 'facility':
              api = 'search/getFacilityInfo'
              params = item.pointId
              break
          }
          if (api) {
            dispatch(api, params, { root: true }).then(result => {
              if (result) {
                dispatch('addWaypointCityAndState', Object.assign(
                  {},
                  item,
                  { pointInfo: Object.assign({}, item.pointInfo, result) }
                ))
              }
            })
          }
        }
      })
    },
    sendRouteDirectly({state}){
      const {activeRoute, truckInfo} = state
      let route = {}
      if (activeRoute.routeType === 'fuelPlan') {
        route = activeRoute.fuelPlanRoute
      } else {
        route = activeRoute
      }
      let routeJson = routeJsonformat(route.routeJson, route.waypointList)
      const params = {
        tripInfo: {
          ...routeJson,
          truckModel: isEmpty(truckInfo) ? {} : truckWebFormatToApi(truckInfo)
        }
      }
      DispatchComponents$.subscribe(x => {
        x.SendRouteDirectly({route: params});
      })
    }
  }
}

export default tripPlan
